// removed by extract-text-webpack-plugin
module.exports = {"header":"header__3r0SF","title":"title__2hIyq","menuLink":"menuLink__2hGaK","menuLinkAvatar":"menuLinkAvatar__3EY0M","avatar":"avatar__3jOMx","caret":"caret__2n47v","dropdownMenu":"dropdownMenu__2GrZ6","menuItemUsername":"menuItemUsername__2rxpU","menuItemUsernameLabel":"menuItemUsernameLabel__3STiP","menuItemLink":"menuItemLink__2MTYc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/globalHeader/style.scss
// module id = 96
// module chunks = 0